(function($) {

    var leadersWrapper = $('.leaders-grid-wrap .leaders-wrapper');
    var leadersWrapperSecondary = leadersWrapper.find('.leaders-wrapper-secondary');
    var leadersElements = leadersWrapper.find('.leader-item');
    var leadersButton = leadersWrapper.parent().find('.more-people');


    leadersButton.on('click', function() {

        leadersButton.addClass('hidden');
        leadersWrapper.css({'transition': '0.5s ease-in-out'});
        leadersWrapper.addClass('hidden');

        setTimeout(function() {
            leadersWrapper.css({'height': leadersWrapperSecondary.outerHeight(), 'transition': 'none'});
            leadersElements.removeClass('hidden');

            leadersWrapper.animate({'height': leadersWrapperSecondary.outerHeight()}, 300, function() {
                setTimeout(function() {
                    leadersWrapper.css({'transition': '0.5s ease-in-out', 'height': 'auto'});
                    leadersWrapper.removeClass('hidden');
                }, 250);
            });

        }, 500);


    });

})( jQuery );